import IconCard from "./IconCard";

export default IconCard;

export { IconCard };
